module.exports = __webpack_public_path__ + "static/media/sd.f9f276bd.svg";